import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './styles.css';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import EventCard from '../EventCard';

import { SwiperNavButtons } from './components/SwiperNavButton';
import { ChevronRight } from '@mui/icons-material';

import { breakpoints } from './constants/breakpoints';
import { useBoundStore } from '../../../stores';

export default function App() {
  const swiper = useSwiper();
  const textPool = useBoundStore((state) => state.textPool);

  const data = [
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'Y. Emre Karanfil',
          src: 'https://avatars.githubusercontent.com/u/77460386?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'Mehmet Ali Kuyucu',
          src: 'https://avatars.githubusercontent.com/u/83474388?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'Amine Sağlık',
          src: 'https://avatars.githubusercontent.com/u/62115401?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'İsmet Ömer Koyuncu',
          src: 'https://avatars.githubusercontent.com/u/79707353?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'M. Çağrı Tepebaşılı',
          src: 'https://avatars.githubusercontent.com/u/28664260?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'Y. Emre Karanfil',
          src: 'https://avatars.githubusercontent.com/u/77460386?v=4',
        },
        {
          name: 'Mehmet Ali Kuyucu',
          src: 'https://avatars.githubusercontent.com/u/83474388?v=4',
        },
        {
          name: 'Amine Sağlık',
          src: 'https://avatars.githubusercontent.com/u/62115401?v=4',
        },
        {
          name: 'İsmet Ömer Koyuncu',
          src: 'https://avatars.githubusercontent.com/u/79707353?v=4',
        },
        {
          name: 'M. Çağrı Tepebaşılı',
          src: 'https://avatars.githubusercontent.com/u/28664260?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'Necmettin Zıvlak',
          src: 'https://avatars.githubusercontent.com/u/105247348?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [
        {
          name: 'Fadimana Kilci',
          src: 'https://avatars.githubusercontent.com/u/37812876?v=4',
        },
      ],
    },
    {
      title: 'Yerlem Etkinliği',
      description: 'Meeting',
      time: '10:00 - 11:00',
      avatars: [],
    },
  ];

  return (
    <>
      <div className="px-5 my-5">
        <div className="flex flex-row max-sm:justify-between items-center gap-10">
          <h1 className="text-[30px] max-sm:text-[20px] my-4">
            {textPool['Son Etkinlikler']}
          </h1>
          <button className="flex flex-row justify-center items-center ">
            <span className="text-[#2BAAE2]">{textPool['Tümünü Göster']}</span>
            <ChevronRight sx={{ color: '#2BAAE2' }} />
          </button>
        </div>
        <Swiper
          className="relative "
          slidesPerView={5}
          spaceBetween={40}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: true,
          }}
          grabCursor={true}
          breakpoints={breakpoints}
          modules={[Autoplay, Pagination, Navigation]}
        >
          {data.map((el, index) => (
            <SwiperSlide key={index}>
              <div className="flex justify-center items-center">
                <EventCard
                  title={el.title}
                  description={el.description}
                  time={el.time}
                  avatars={el.avatars}
                />
              </div>
            </SwiperSlide>
          ))}
          <SwiperNavButtons />
        </Swiper>
      </div>
    </>
  );
}
